import { useEffect, useRef } from 'react';
import { Result } from 'antd';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../hooks/useAuth';

/**
 * 退会完了画面。
 * 退会は即時に成立しているため、この画面でサインアウトしてセッションを破棄する。
 * 削除予定日・復旧手順は一切表示しない。
 */
export function WithdrawalCompletePage() {
  const { t } = useTranslation();
  const auth = useAuth();
  const signedOut = useRef(false);

  useEffect(() => {
    if (signedOut.current) return;
    signedOut.current = true;
    auth.signOutCognito();
  }, [auth]);

  return (
    <Result
      status="success"
      title={t('withdrawal.completeTitle')}
      subTitle={t('withdrawal.completeDesc')}
    />
  );
}
